import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import classnames from 'classnames';
import { mergeStyleSets } from '@fluentui/react';
import { insertPopoverContainer } from '@bingads-webui-campaign/fluctuation-common';
import { GridTooltip } from '@bingads-webui-campaign/grid-tooltip';

export const campaignManagedDateContainerId = 'campaign-managed-date-tooltip';

export const dismissCampaignManagedDateCallout = () => {
  const calloutElement = document.getElementById(campaignManagedDateContainerId);
  if (calloutElement) {
    ReactDOM.unmountComponentAtNode(calloutElement);
  }
};

export const renderCampaignManagedDateTooltip = ({
  i18n, event, view,
}) => {
  const styles = mergeStyleSets({
    content: {
      marginBottom: '8px',
    },
  });

  const { right } = event.target.getBoundingClientRect();
  const calloutMaxWidth = 325; // this value is defined in global style
  const placement = right + calloutMaxWidth > window.innerWidth ? 'left' : 'right';

  insertPopoverContainer(campaignManagedDateContainerId);
  const tooltipProps = {
    parentView: view,
    popoverId: 'campaign-managed-date-tooltip-id',
    target: event.currentTarget,
    show: true,
    onClose: dismissCampaignManagedDateCallout,
    onMouseLeave: dismissCampaignManagedDateCallout,
    closeButton: false,
    placement,
    focusLockContent: true,
    content: (
      <>
        <div className={classnames('campaign-managed-date-info', styles.content)} variant="small">
          {i18n.getString('CampaignManagedDate_Tooltip')}
        </div>
      </>
    ),
  };

  ReactDOM.render(
    <GridTooltip {...tooltipProps} />,
    document.getElementById(campaignManagedDateContainerId)
  );
};

export const hideCampaignManagedDateTooltip = ({ event, view }) => {
  if ($(event.relatedTarget).closest('#campaign-managed-date-tooltip-id').length === 0) {
    view.trigger('closePopup');
  }
};
